// @ts-nocheck
import * as GraphQLSchema from '../graphql-types';

import * as Operations from './get-agreement-rates-from-agreement-query.graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetAgreementRatesFromAgreementQueryVariables = GraphQLSchema.Exact<{
  id: GraphQLSchema.Scalars['ID']['input'];
}>;


export type GetAgreementRatesFromAgreementQuery = { __typename?: 'Query', agreement?: { __typename?: 'Agreement', agreementRates: Array<{ __typename?: 'AgreementRate', id: string, rateCents?: number | null, clientNetDollars?: string | null, workerNetDollars?: string | null, rateName?: string | null, flatRate: boolean, grossDollars?: string | null, rateDescription?: string | null, rateSchedule?: { __typename?: 'RateSchedule', weekday?: boolean | null, saturday?: boolean | null, sunday?: boolean | null, publicHoliday?: boolean | null, daytime?: boolean | null, evening?: boolean | null, overnight?: boolean | null } | null, budgetSupportTypes?: Array<{ __typename?: 'BudgetSupportType', id: string, name: string, displayName?: string | null, isAdminOnlyType?: boolean | null }> | null }> } | null };


  @Injectable({
    providedIn: 'root'
  })
  export class GetAgreementRatesFromAgreementQueryService extends Apollo.Query<GetAgreementRatesFromAgreementQuery, GetAgreementRatesFromAgreementQueryVariables> {
    document = Operations.GetAgreementRatesFromAgreementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }